import AttributePanel from "../AttributePanel/AttributePanel";
import { CharacterData } from "../../../../utils/game/character/CharacterData";
import StatBoard from "../../../../utils/game/mechanics/StatBoard";
import FlexColumn from "../../../../common/components/layout/Flexbox/FlexColumn";
import FlexRow from "../../../../common/components/layout/Flexbox/FlexRow";

type Props = {
    alignment?: "start" | "center" | "end";
    characterData: CharacterData;
    statBoard: StatBoard;
    onAttributeTitleClick?: (attributeName: string) => void;
};

export default function AttributesContainer({
    alignment,
    characterData,
    statBoard,
    onAttributeTitleClick,
}: Props): JSX.Element {
    return (
        <FlexColumn width={"full"} style={{ marginBottom: "4px" }}>
            <FlexRow alignment="center">
                <div
                    style={{
                        fontSize: "80%",
                        fontWeight: "bold",
                        padding: 4,
                    }}
                >
                    Attributes
                </div>
            </FlexRow>
            <FlexRow alignment={alignment} wrap={true}>
                <AttributePanel statBoard={statBoard} statKey="AWA" onAttributeTitleClick={() => {onAttributeTitleClick?.("Awareness")}} />
                <AttributePanel statBoard={statBoard} statKey="WGTALL" onAttributeTitleClick={() => {onAttributeTitleClick?.("Weight Allowance")}} />
                <AttributePanel statBoard={statBoard} statKey="REG" onAttributeTitleClick={() => {onAttributeTitleClick?.("Regen")}} />
                <AttributePanel statBoard={statBoard} statKey="SUR" onAttributeTitleClick={() => {onAttributeTitleClick?.("Survival")}} />
                <AttributePanel statBoard={statBoard} statKey="WIL" onAttributeTitleClick={() => {onAttributeTitleClick?.("Willpower")}} />
                <AttributePanel statBoard={statBoard} statKey="STLTH" onAttributeTitleClick={() => {onAttributeTitleClick?.("Stealth")}} />
            </FlexRow>
        </FlexColumn>
    );
}
